'use client';

import { useMemo } from 'react';
import { useAuthStore } from '@/stores/user.store';
import { AbmHeader, type AbmHeaderNavGroup } from '../components/abm-header';
import {
  ABM_ACCOUNT_HREF,
  ABM_COPY,
  ABM_FIND_PARKING_HREF,
  ABM_LOGIN_HREF,
  ABM_LOGO_SIZE,
  ABM_LOGO_SRC,
  ABM_NAV_CONTACT,
  ABM_NAV_INDUSTRIES,
  ABM_NAV_NEWS,
  ABM_NAV_SERVICES,
} from '../content/abm-site.content';

const GROUPS: AbmHeaderNavGroup[] = [
  { id: 'industries', viewAllLabel: ABM_COPY.viewAll, ...ABM_NAV_INDUSTRIES },
  { id: 'services', viewAllLabel: ABM_COPY.viewAll, ...ABM_NAV_SERVICES },
];

const LEADING_LINKS = [{ label: ABM_COPY.findParking, href: ABM_FIND_PARKING_HREF }, ABM_NAV_NEWS];

/** Connects the ABM header to the signed-in state: Log In for a guest, My Account otherwise. */
export function AbmSiteHeader() {
  const isLoggedIn = useAuthStore((state) => !!state.user);
  const accountLink = useMemo(
    () =>
      isLoggedIn
        ? { label: ABM_COPY.myAccount, href: ABM_ACCOUNT_HREF }
        : { label: ABM_COPY.logIn, href: ABM_LOGIN_HREF },
    [isLoggedIn]
  );

  return (
    <AbmHeader
      logoSrc={ABM_LOGO_SRC}
      logoSize={ABM_LOGO_SIZE}
      logoAlt={ABM_COPY.brandName}
      homeHref="/"
      navAriaLabel={ABM_COPY.primaryNavAriaLabel}
      openMenuLabel={ABM_COPY.openMenu}
      closeMenuLabel={ABM_COPY.closeMenu}
      newTabLabel={ABM_COPY.opensInNewTab}
      leadingLinks={LEADING_LINKS}
      groups={GROUPS}
      trailingLinks={[ABM_NAV_CONTACT]}
      accountLink={accountLink}
    />
  );
}
